import gql from 'graphql-tag'
import {
	clients as clientsFragment,
	cashRegisters as cashRegistersFragment
} from './fragments'

export const clients = gql`
mutation CA_Mutation_updateCreditClient_Clients($id: ID!, $fields: CreditClientFields) {
	cashAssist {
		updateCreditClient(id: $id, fields: $fields) {
			id
			...clientsmain
		}
	}
}
${clientsFragment}`

export const cashRegisters = gql`
mutation CA_Mutation_updateCreditClient_CashRegisters($id: ID!, $fields: CreditClientFields!) {
	cashAssist {
		updateCreditClient(id: $id, fields: $fields) {
			id
			...cashRegisters
		}
	}
}
${cashRegistersFragment}`

// export const cashRegisters = gql`
// mutation CAmaster_updateMedia_cashRegisters($id: ID! $fields: MediaFields!) {
//   updateMedia(id: $id, fields: $fields) {
//     id
//     mod_ver
//     cashRegisterId
//   }
// }
// `

export default {
	clients,
	cashRegisters
	// additive
}
